export default __webpack_public_path__ + "static/0192-6665d033874214657a52420caa44b724.png";